<div class="hom-staging-view">
  <bfx-hedge-order-staging-grid
    #stagingGrid
    fxFlex="1 1 auto"
    fxLayout="column"
    [columnsConfig]="columnsConfiguration"
    (gridReady)="onStagingGridReady()"
    (bulkEditChange)="onBulkEditChange($event)"
  >
  </bfx-hedge-order-staging-grid>
  <div class="staging-divider"></div>

  <div class="hom-action-bar" fxFlex="0 0 auto">
    <div class="hom-control-bar" fxFlex="0 0 auto">
      <button
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="newOrder()"
        [disabled]="newDisabled"
      >
        <i class="bfx-button-icon icon-add"></i>
        <span>{{ data.button_labels.new | translate }}</span>
      </button>
      <button
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="copy()"
        [disabled]="copyDisabled"
      >
        <i class="bfx-button-icon icon_ion_content_copy"></i>
        <span>{{ data.button_labels.copy | translate }}</span>
      </button>
      <button
        type="button"
        class="bfx-button-secondary-moderate"
        (click)="delete()"
        [disabled]="deleteDisabled"
      >
        <i class="bfx-button-icon icon-remove"></i>
        <span>{{ data.button_labels.delete | translate }}</span>
      </button>
    </div>

    <div class="hom-control-bar" fxFlex="0 0 auto">
      <span>{{ data.button_labels.bulk_edit | translate }}</span>
      <bfx-toggle
        fxFlex="0 0 auto"
        [checked]="data.bulk_edit_value"
        (change)="onBulkEditChange($event)"
      ></bfx-toggle>
    </div>

    <div fxFlex="1 1"></div>

    <div fxFlex="0 0 auto">
      <button
        type="button"
        class="bfx-button-primary"
        (click)="submit()"
        [disabled]="submitDisabled"
      >
        <span>{{ data.button_labels.submit | translate }}</span>
      </button>
    </div>
  </div>
</div>
